import React, { useEffect } from 'react';
import Chatbot from './Chatbot';
import { initGA, trackPageView } from './services/analytics';
import Imprezia from '@adimpress/imprezia-sdk';

function App() {
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname + window.location.search);
    
    Imprezia.init({
      apiKey: process.env.REACT_APP_IMPREZIA_API_KEY,
      endpoint: process.env.REACT_APP_IMPREZIA_ENDPOINT,
      impressionEndpoint: process.env.REACT_APP_IMPREZIA_IMPRESSION_ENDPOINT,
    });
    console.log('Imprezia SDK initialized');
  }, []);

  return (
    <Chatbot />
  );
}

export default App;
